import config from 'config'
import moment from 'moment'
import { user } from 'ampersand-app'

import transactionConfig from '@/modules/transaction/config'

const toInvoicePosition = miteTracking => {
  const defaultVat = user.getDefaultVatByDate(miteTracking.createdAt)

  const returnRegex = /(\r\n|\n|\r)/gm
  const formattedDescription = miteTracking.note
    .split(returnRegex)
    .filter(part => part.match(returnRegex) === null)
    .map(part => `<p>${part}</p>`)
    .join('')
  const description = `<p><b>${moment(miteTracking.createdAt).format(
    config.dateFormat.client,
  )}</b></p>${formattedDescription}`

  return {
    metaData: {
      id: null,
      pricePerHour: miteTracking.pricePerHour,
      type: transactionConfig.positionTypes.MITE,
    },
    unit: 'Std.',
    title: 'Zeitaufwand',
    vatPercent: user.isSmallBusiness ? 0.0 : defaultVat?.value,
    priceNet: miteTracking.pricePerHour,
    amount: miteTracking.minutes / 60,
    description,
  }
}

export default toInvoicePosition
